export type DeviceType = 'ios' | 'android'

export const getDeviceType = (userAgent: string): DeviceType | '' => {
  const isiOS = /iPhone|iPad|iPod|Macintosh/i.test(userAgent)
  const isAndroid = /Android/i.test(userAgent)

  if (isiOS) return 'ios'

  if (isAndroid) return 'android'

  return ''
}
